
export default {
  name: 'OptionSelect',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default: null
    },
    availability: {
      type: Boolean,
      default: true
    }
  },
  vessel: {
    label: {
      color: 'grey-darker',
      fontSize:  'xs'
    },
    soldOut: {
      $extend: 'label',
      color: 'danger'
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.selected = newValue
      }
    }
  },
  data() {
    return {
      selected: null
    }
  },
  methods: {
    onChange(value) {
      this.$emit('input', value)
    },
    available(item) {
      return item.quantity > 0
    },
    backorderable(item) {
      return item.quantity == 0 && !item.disabled
    },
    fewLeft(item) {
      return this.available(item) && item.quantity < 10
    }
  }
}
